/**
 * Catálogo do domínio `juridico` (T52, CAT-01).
 *
 * Origem: `src/shared/autorizacao/Juridico.ts`.
 *
 * É o domínio que mostra o padrão OPOSTO ao de `materiais` e `contratos`: aqui as
 * duas concessões por relação estão **fora** de qualquer `temPermissao`
 * (`Juridico.ts:22,26`). Quem é o responsável de DP de um processo faz upload de
 * DP naquele processo, tendo ou não papel no domínio — e é assim que deve ser,
 * porque a relação é a autorização.
 *
 * Por isso elas são concessão de base, não de papel.
 *
 * **O que a T49 já corrigiu e não se repete aqui:** as ações continuam
 * `upload_dp` e `upload_seg`, com o setor codificado no nome. É o defeito que o
 * `PADRONIZACAO-ROLES.md §7` nomeia, e a correção seria `upload` com a relação
 * distinguindo — mas as relações **já** distinguem (`responsavel_dp` e
 * `responsavel_seg`), então trocar as duas ações por uma só `upload` colapsaria
 * duas concessões em uma e daria upload de segurança a quem só é responsável de
 * DP. Mantidas como estão; a limpeza do nome da ação é decisão à parte.
 */
import type { Concessao, NomePapel, Papel } from "../catalogo/vocabulario";

/**
 * As duas relações de responsabilidade sobre o processo. Concedem sem papel
 * nenhum, como hoje — a relação no registro É a autorização.
 */
export const CONCESSOES_BASE_JURIDICO: readonly Concessao[] = [
  {
    acoes: ["upload_dp"],
    recurso: "ProcessoJuridico",
    exigeRelacao: ["responsavel_dp"],
  },
  {
    acoes: ["upload_seg"],
    recurso: "ProcessoJuridico",
    exigeRelacao: ["responsavel_seg"],
  },
];

export const PAPEIS_JURIDICO = {
  "juridico.admin": {
    dominio: "juridico",
    nivel: "admin",
    concessoes: [{ acoes: ["manage"], recurso: "ProcessoJuridico" }],
  },
  "juridico.leitura": {
    dominio: "juridico",
    nivel: "leitura",
    // JUR-01 (conferência de acessos, 2026-10-01): a leitura enxerga só o processo
    // em que a pessoa é responsável de DP ou de segurança. Revoga a decisão 6 do
    // ADR-0004 ("`juridico.leitura` vê todos os processos"); o admin continua
    // lendo tudo, por `manage`.
    concessoes: [
      {
        acoes: ["read"],
        recurso: "ProcessoJuridico",
        exigeRelacao: ["responsavel_dp", "responsavel_seg"],
      },
    ],
  },
} as const satisfies Partial<Record<NomePapel, Papel>>;
